import api from './api';

export interface UserPreferences {
  skipVoiceOnboardingTour?: boolean;
}

const BASE = '/users/me/preferences';

export const userPreferencesApi = {
  get: (): Promise<UserPreferences> => api.get<UserPreferences>(BASE).then((r) => r.data),
  patch: (patch: UserPreferences): Promise<UserPreferences> =>
    api.patch<UserPreferences>(BASE, patch).then((r) => r.data),
};
